var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ApolloClient, ApolloLink, InMemoryCache, Observable, } from "@apollo/client";
import { BatchHttpLink } from "@apollo/client/link/batch-http";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { HttpLink } from "@apollo/client/link/http";
import { RetryLink } from "@apollo/client/link/retry";
import { IS_SSR } from "@uplift-ltd/constants";
import { captureException, captureMessage } from "@uplift-ltd/sentry";
import { GRAPHQL_AUTH_URL } from "./constants";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var globalApolloClient;
var defaultFetch = typeof window !== "undefined" ? window.fetch : undefined;
export var configureClient = function (_a) {
    var _b = _a.initialState, initialState = _b === void 0 ? {} : _b, _c = _a.cache, cache = _c === void 0 ? new InMemoryCache() : _c, _d = _a.fetch, fetch = _d === void 0 ? defaultFetch : _d, fetchOptions = _a.fetchOptions, _e = _a.batch, batch = _e === void 0 ? true : _e, batchInterval = _a.batchInterval, batchKey = _a.batchKey, batchMax = _a.batchMax, _f = _a.extraLinks, extraLinks = _f === void 0 ? [] : _f, cookie = _a.cookie, getToken = _a.getToken, removeToken = _a.removeToken, onNetworkError = _a.onNetworkError, onGraphqlErrors = _a.onGraphqlErrors, onNotAuthorized = _a.onNotAuthorized, onForbidden = _a.onForbidden, otherOptions = __rest(_a, ["initialState", "cache", "fetch", "fetchOptions", "batch", "batchInterval", "batchKey", "batchMax", "extraLinks", "cookie", "getToken", "removeToken", "onNetworkError", "onGraphqlErrors", "onNotAuthorized", "onForbidden"]);
    cache.restore(initialState);
    // eslint-disable-next-line consistent-return
    var errorLink = onError(function (_a) {
        var _b, _c, _d;
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, operation = _a.operation;
        if (networkError) {
            if (operation.operationName === "CurrentUser") {
                // response.errors = null;
                // response is undefined for networkError so we return a fake store
                // https://github.com/apollographql/apollo-link/issues/855
                return Observable.of({ data: { currentUser: null } });
            }
            console.warn("[Network error]: ".concat(networkError));
            // pluck errors out of the result and send to sentry
            // typing says result is an object but since we use batch http link it's actually an array
            var serverError = networkError;
            var errors = ((_b = serverError.result) === null || _b === void 0 ? void 0 : _b.errors) ||
                (
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (_d = (_c = serverError.result) === null || _c === void 0 ? void 0 : _c.map) === null || _d === void 0 ? void 0 : _d.call(_c, function (result) { return result.errors; }));
            captureException(networkError, {
                extra: {
                    operationName: operation.operationName,
                    query: operation.query,
                    errors: errors,
                },
            });
            onNetworkError && onNetworkError(networkError, operation);
            // If we get a 401, we log out the user
            if (networkError.statusCode === 401) {
                removeToken && removeToken();
                onNotAuthorized && onNotAuthorized(networkError, operation);
            }
            else if (networkError.statusCode === 403) {
                onForbidden && onForbidden(networkError, operation);
            }
        }
        if (graphQLErrors) {
            graphQLErrors.forEach(function (graphqlError) {
                // This is not supposed to be a string, but it is sometimes?
                // Maybe it's a graphene thang? Anyway, we'll handle it.
                if (typeof graphqlError === "string") {
                    console.warn("[GraphQL error]: Message: ".concat(graphqlError));
                }
                // Default apollo handling
                else {
                    var message = graphqlError.message, locations = graphqlError.locations, path = graphqlError.path;
                    console.warn("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
                }
            });
            captureMessage("GraphQL Errors", {
                extra: {
                    operationName: operation.operationName,
                    query: operation.query,
                    errors: graphQLErrors,
                },
            });
            if (graphQLErrors.length > 0 && onGraphqlErrors) {
                onGraphqlErrors(graphQLErrors, operation);
            }
        }
    });
    var authLink = setContext(function (_, _a) {
        var headers = _a.headers;
        return __awaiter(void 0, void 0, void 0, function () {
            var extraHeaders, token, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        extraHeaders = {};
                        _b = getToken;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, getToken()];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        token = _b;
                        if (token) {
                            extraHeaders.authorization = "Bearer ".concat(token);
                        }
                        if (cookie) {
                            extraHeaders.cookie = cookie;
                        }
                        return [2 /*return*/, {
                                headers: __assign(__assign({}, headers), extraHeaders),
                            }];
                }
            });
        });
    });
    var retryLink = new RetryLink({
        attempts: {
            max: IS_SSR ? 1 : 5,
        },
    });
    var links = __spreadArray([errorLink, retryLink, authLink], extraLinks, true);
    if (batch) {
        links.push(new BatchHttpLink({
            uri: GRAPHQL_AUTH_URL,
            credentials: "same-origin",
            fetch: fetch,
            fetchOptions: fetchOptions,
            batchInterval: batchInterval,
            batchKey: batchKey,
            batchMax: batchMax,
        }));
    }
    else {
        links.push(new HttpLink({
            uri: GRAPHQL_AUTH_URL,
            credentials: "same-origin",
            fetch: fetch,
            fetchOptions: fetchOptions,
        }));
    }
    return new ApolloClient(__assign({ ssrMode: IS_SSR, link: ApolloLink.from(links), cache: cache }, otherOptions));
};
export var initClient = function (options) {
    if (IS_SSR) {
        return configureClient(options);
    }
    if (!globalApolloClient) {
        globalApolloClient = configureClient(options);
    }
    return globalApolloClient;
};
